module.exports = __webpack_public_path__ + "img/canary-islands.84ef5084.svg";